export enum TestParamMappingActionTypes {
    API_RESPONSE_SUCCESS = '@@testParamMapping/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@testParamMapping/API_RESPONSE_ERROR',

    ADD_TEST_PARAM_MAPPING = '@@testParamMapping/ADD_TEST_PARAM_MAPPING',
    EDIT_TEST_PARAM_MAPPING = '@@testParamMapping/EDIT_TEST_PARAM_MAPPING',
    GET_TEST_PARAM_MAPPINGS = '@@testParamMapping/GET_TEST_PARAM_MAPPINGS',
    GET_TEST_PARAM_MAPPING = '@@testParamMapping/GET_TEST_PARAM_MAPPING',
    GET_TEST_PARAMS = '@@testParamMapping/GET_TEST_PARAMS',
    RESET = '@@testParamMapping/RESET',
    RESET_SUCCESS = '@@testParamMapping/RESET_SUCCESS',
    RESET_ERROR = '@@testParamMapping/RESET_ERROR',
}
